import React, { ReactNode } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS as DndCSS } from "@dnd-kit/utilities";

// ─── Component ───────────────────────────────────────────────────────────────

const CardMeGenSortableScene: React.FC<{
  id: string;
  children: (dragHandleProps: React.HTMLAttributes<HTMLElement>) => ReactNode;
}> = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.id,
  });
  const style: React.CSSProperties = {
    transform: DndCSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: "relative",
    zIndex: isDragging ? 999 : "auto",
  };
  const { color, ...safeAttributes } = attributes as any;
  return (
    <div id="megen-sortable-scene-root" ref={setNodeRef} style={style}>
      {props.children({ ...safeAttributes, ...listeners })}
    </div>
  );
};

export default CardMeGenSortableScene;
